import {
  type ComparisonTableProps,
  ComparisonTablePropsSchema,
  replaceTags
} from '@ecomm/scout'
import { tap, z } from '@simplisafe/ewok'
import { pipe } from 'fp-ts/lib/function'

const comparisonTableJson = z.object({
  comparisonTable: z.object({
    content: z.object({
      internal: z.object({
        content: z.string()
      })
    })
  })
})

/**
 * TODO: ECP-12911
 *
 * This is a fork of the function from scout to work with the JSON data for the
 * OdmonMediaPageComponents.
 *
 * It shouldn't be used anywhere else, and the source function should be fixed to just work correctly.
 * It might also be getting data from different sources and should just be different functions.
 */
export function transformToComparisonTableData(
  data: unknown,
  _key?: string
): ComparisonTableProps {
  const table = pipe(
    comparisonTableJson.parse(data, {
      path: [
        'OdmonMediaPageComponents',
        'transformToComparisonTableData',
        'comparisonTableJson'
      ]
    }).comparisonTable.content.internal.content,
    tap('table'),
    JSON.parse,
    ComparisonTablePropsSchema.parse
  )

  return {
    ...table,
    footer: (
      <span>
        {table.footer.map(str => (
          <span className="mt-2 block" key={`${str}-footer`}>
            {replaceTags(str)}
            <br />
          </span>
        ))}
      </span>
    )
  }
}
